<template>
  <select class="form-control" v-model="agent" @change="save">
    <option :value="null" v-if="agent == null">---</option>
    <option v-for="user in users" :value="user.id">{{ user.first_name }} {{ user.last_name }}</option>
  </select>
</template>
<script>
import _ from 'lodash';
import Api from '@/store/jsonapi';
import Alerts from '@/utils/alerts';

export default {
  props: ['customer', 'agent_type'],
  data: function () {
    return {
      users: [],
      agent: 0
    };
  },
  created() {
    this.agent = null;

    if (this.customer[this.agent_type]) {
      this.agent = this.customer[this.agent_type].id;
    }

    this.fetch();
  },
  methods: {
    fetch() {
      Api.findAllPages('staffs').then(({ data }) => {
        this.users = data;
      });
    },
    save: function () {
      const agent = this.users.find((x) => x.id === this.agent);

      const payload = {
        id: this.customer.id
      };
      payload[this.agent_type] = {
        id: this.agent
      };

      Api.update('customers', payload).then((x) => {
        this.customer[this.agent_type] = agent;

        Alerts.success({
          title: this.$i18n.t('success'),
          detail: this.$i18n.t('agent_saved')
        });
      });
    }
  }
};
</script>

<style scoped></style>
